export default __webpack_public_path__ + "static/media/django.11e906e8.svg";